import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=b1e84cce&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e84cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e84cce')) {
      api.createRecord('b1e84cce', component.options)
    } else {
      api.reload('b1e84cce', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=b1e84cce&scoped=true&", function () {
      api.rerender('b1e84cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qc23xah3NoK0/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports